var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-msg-box"},[_vm._v("\n  You don't have access to the microphone\n  "),_c('div',{staticClass:"triangle"})])}]

export { render, staticRenderFns }